import mediaSales from './mediaSales';

export default mediaSales;
